import React from "react";
import PropTypes from "prop-types";
import { DropdownLight } from "@weezevent/nacre";
import Style from "./page-size-dropdown.module.scss";

export default function PageSizeDropdown({
	pageSize,
	onChange = () => {},
	labelRender = "",
	pageSizeOptions
}) {
	const pageSizeToOption = value => ({
		key: value,
		label: labelRender(value),
		value: value
	});

	return (
		<DropdownLight
			position={"bottom-end"}
			className={Style["page-size-dropdown"]}
			value={pageSize}
			onChange={onChange}
			items={pageSizeOptions.map(pageSizeToOption)}
		/>
	);
}

PageSizeDropdown.propTypes = {
	onChange: PropTypes.func,
	pageSize: PropTypes.number.isRequired,
	labelRender: PropTypes.func,
	pageSizeOptions: PropTypes.arrayOf(PropTypes.number)
};

PageSizeDropdown.defaultProps = {
	onChange: () => {},
	labelRender: v => String(v),
	pageSizeOptions: [50, 100, 250, 500]
};
